<template>

  <UserLayout ref="layout"  pageTitle="Pianificazione interventi">
      <template #page-content="props">
          <v-card class="form-card" style="width: 99%" outlined :elevation="10">
            <FrmPlanner v-bind:height="plannerHeight" 
            
            :allow-drag-and-drop-events="Boolean(true)"></FrmPlanner>
          </v-card>
    </template>
 </UserLayout> 
</template>


<script>
import FrmPlanner from "../components/Planner/FrmPlanner";
import UserLayout from "../layout/UserLayout";
import UISettingsHelper from "../utils/UISettingsHelper";
import SessionHelper from "../utils/SessionHelper";
export default { 
    data:function(){
        return{ 
            windowHeight:0,
        }
    },
  components: {
    FrmPlanner,
    UserLayout,
  },
  mounted() {
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
      UISettingsHelper.Configure(this.$route.params.companyAlias); 
      this.windowHeight =window.innerHeight;//this.$refs.layout.clientHeight;// window.innerHeight-100; 
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;//this.$refs.layout.clientHeight;//window.innerHeight-300;
    });
  },
  computed: {
    plannerHeight() { 
      return this.windowHeight-400;
    }, 
    }
};
</script>